import heydoctor from './heydoctor';

export default {
  ...heydoctor,
  Name: 'GoodRx',
  Cobranded: false,
  BaseUrl: 'https://heydoctor.goodrx.com',
} as const;
